import { byPlatform } from 'utils/platforms';

export const COLORS = {
    trackBarBg: byPlatform('#2CBE77', '#4ABB6D'),
    resultedProductBg: '#edf1f8',
    resultedProductText: '#9198AA',
    defaultShortcutBg: '#46B16F',
};
